import React from "react";
import { NavLink, useNavigate, Link } from "react-router-dom";
import { LayoutDashboard, Package, Layers, FolderTree, ShoppingCart, Tag, FileText, Star, Users, Megaphone, Truck, LogOut, Store, Mail, BarChart3 } from "lucide-react";
import { useStore } from "@/context/StoreContext";

const LINKS = [
  ["/admin", "Dashboard", LayoutDashboard, true],
  ["/admin/analytics", "Visitor Stats", BarChart3],
  ["/admin/messages", "Messages", Mail],
  ["/admin/discounts", "Discounts", Tag],
  ["/admin/reviews", "Reviews", Star],
  ["/admin/customers", "Customers", Users],
  ["/admin/content", "Content & Pages", FileText],
  ["/admin/announcements", "Announcements", Megaphone],
  ["/admin/delivery", "Delivery", Truck],
];

export default function AdminLayout({ children }) {
  const { logout } = useStore();
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex bg-brand-bg">
      <aside className="w-60 bg-brand-ink text-white flex flex-col fixed inset-y-0 overflow-y-auto">
        <Link to="/admin" className="font-serif-display text-2xl px-6 py-6 border-b border-white/10">Crochet Kerry</Link>
        <nav className="flex-1 py-4">
          {LINKS.map(([to, label, Icon, end]) => (
            <NavLink key={to} to={to} end={end} className={({ isActive }) => `flex items-center gap-3 px-6 py-2.5 text-sm transition-colors ${isActive ? "bg-brand-pink text-brand-ink" : "text-white/70 hover:text-white hover:bg-white/5"}`} data-testid={`admin-nav-${label.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
              <Icon className="w-4 h-4" /> {label}
            </NavLink>
          ))}
        </nav>
        <div className="border-t border-white/10 py-3">
          <Link to="/" className="flex items-center gap-3 px-6 py-2.5 text-sm text-white/70 hover:text-white"><Store className="w-4 h-4" /> View shop</Link>
          <button onClick={() => { logout(); navigate("/admin/login"); }} className="flex items-center gap-3 px-6 py-2.5 text-sm text-white/70 hover:text-white w-full" data-testid="admin-logout"><LogOut className="w-4 h-4" /> Sign out</button>
        </div>
      </aside>
      <main className="flex-1 ml-60 p-8 max-w-full overflow-x-hidden">{children}</main>
    </div>
  );
}
